import React from 'react';
import { observer } from 'mobx-react';
import { Heading, Box, Tabs, TabList, TabPanels, Tab, TabPanel } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { useStores } from 'hooks/useStores';
import GamePanel from './components/GamePanel';

function HomePage() {
  const { t } = useTranslation();
  const {
    gamesStore: {
      games,
      gamesInfo,
    },
  } = useStores();

  return (
    <Box>
      <Heading>
        {t('Admin Pyk.pl')}
      </Heading>
      <Box>
        <Tabs isLazy>
          <TabList>
            {games.map(({ id, name, shortName }) => (
              <Tab key={id}>
                {`${name} (${gamesInfo.find(({ name }) => name === shortName)?.players || '~'})`}
              </Tab>
            ))}
          </TabList>

          <TabPanels>
            {games.map((game) => (
              <TabPanel key={`panel-${game.id}`}>
                <GamePanel {...game} />
              </TabPanel>
            ))}
          </TabPanels>
        </Tabs>
      </Box>
    </Box>
  )

}

export default observer(HomePage);
